// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"JJ7Dfv4cy48rn2gj"};